import React, { useState, useEffect, useRef } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {matchesAnyRegex} from "../App/utils.js";

let activeDropzones = new Set();

const Dropzone = ({ onFileUpload, message = "Drop file here", types = [], id }) => {
    const [isDragging, setIsDragging] = useState(false);
    const dropzoneRef = useRef();

    useEffect(() => {
        if (window?.openkbs?.disableDropzone) return;
        const dragEvents = ['dragenter', 'dragover', 'dragleave', 'drop'];

        const dragenterListener = event => {
            event.preventDefault();
            setIsDragging(true);
            activeDropzones.add(id);
        };

        const dragleaveListener = event => {
            event.preventDefault();
            if (dropzoneRef.current && !dropzoneRef.current.contains(event.relatedTarget)) {
                setIsDragging(false);
                activeDropzones.delete(id);
            }
        };

        const dropListener = event => {
            if (activeDropzones.has(id)) {
                event.preventDefault();
                setIsDragging(false);
                let files = [...event.dataTransfer.files];
                if (files && files.length > 0 && matchesAnyRegex(files[0].type, types)) {
                    onFileUpload(files[0]);
                    activeDropzones.clear();
                    window.dispatchEvent(new CustomEvent('dropzone-file-uploaded'));
                }
            }
        };

        const fileUploadedListener = () => {
            setIsDragging(false);
            activeDropzones.delete(id);
        };

        dragEvents.forEach(eventName => {
            window.addEventListener(eventName, dragenterListener);
        });

        window.addEventListener('dragleave', dragleaveListener);
        window.addEventListener('drop', dropListener);
        window.addEventListener('dropzone-file-uploaded', fileUploadedListener);

        return () => {
            dragEvents.forEach(eventName => {
                window.removeEventListener(eventName, dragenterListener);
            });
            window.removeEventListener('dragleave', dragleaveListener);
            window.removeEventListener('drop', dropListener);
            window.removeEventListener('dropzone-file-uploaded', fileUploadedListener);
        };
    }, [onFileUpload, id]);

    return isDragging ? (
        <Box
            ref={dropzoneRef}
            style={{
                border: '2px dashed #fff',
                position: 'fixed',
                top: '20%',
                bottom: '20%',
                left: '20%',
                right: '20%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                zIndex: 9999
            }}
        >
            <CloudUploadIcon style={{fontSize: 120, color: '#fff'}} />
            <Typography variant="h6" style={{color: '#fff'}}>{message}</Typography>
        </Box>
    ) : null;
};

export default Dropzone;